import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { IRiskLevel } from '@interfaces/riskLevels';
import { handleGetAdminRiskLevels } from '@store/features/adminRiskLevels/actions';
import {
  adminRiskLevelsErrorSelector,
  adminRiskLevelsIsLoadingSelector,
  adminRiskLevelsIsReadySelector,
  adminRiskLevelsSelector,
} from '@store/features/adminRiskLevels/selectors';
import { removeAdminRiskLevels } from '@store/features/adminRiskLevels/slice';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useAdminRiskLevelsByProgramCode = (programCode?: number): IRiskLevel[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(adminRiskLevelsSelector);
  const isLoading = useSelector(adminRiskLevelsIsLoadingSelector);
  const isReady = useSelector(adminRiskLevelsIsReadySelector);
  const error = useSelector(adminRiskLevelsErrorSelector);

  const handleFetch = useCallback(() => {
    programCode && dispatch(handleGetAdminRiskLevels({ programCode }));
  }, [dispatch, programCode]);

  useEffect(() => {
    dispatch(removeAdminRiskLevels());
  }, [dispatch, programCode]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.adminRiskLevelsError'),
    handleFetch,
  });

  return data;
};

export default useAdminRiskLevelsByProgramCode;
